<clr-modal [(clrModalOpen)]="showAddFloorPlan" [clrModalClosable]="false">
  <h3 class="modal-title">Add floorplan</h3>
  <div class="modal-body">
    <form clrForm *ngIf="childFloorplans">

      <clr-select-container style="margin-top: 0px;">
        <label>Seelct:</label>
        <select clrSelect name="addfloorplan" [(ngModel)]="addFloorplanInfo">
          <option *ngIf="defaultFloorplanInfo" [ngValue]="defaultFloorplanInfo">{{defaultFloorplanInfo.name}}</option>
          <option *ngFor="let addItem of childFloorplans" [ngValue]="addItem">{{addItem.name}}</option>
        </select>
      </clr-select-container>

      <clr-toggle-container>
        <clr-toggle-wrapper>
          <input type="checkbox" clrToggle
            [(ngModel)]="addDefault" name="adddefaul" />
          <label>Default plan</label>
        </clr-toggle-wrapper>
      </clr-toggle-container>

      <clr-input-container>
        <label>Floor:</label>
        <input clrInput type="number" step="1" placeholder="" name="addfloor" [(ngModel)]="addFloor" [disabled]="addDefault"/>
      </clr-input-container>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="showAddFloorPlan = false">Cancel</button>
    <button type="button" class="btn btn-primary"
      (click)="showAddFloorPlan = false; addFloorplan()">Add</button>
  </div>
</clr-modal>

<form clrForm>
  <clr-select-container style="margin-top: 0px;">
    <label>Select floorplan</label>
    <select clrSelect name="selectfloorplan" [(ngModel)]="selectedPlanId"
      (ngModelChange)="selectedFloorPlanChange($event)">
      <option *ngFor="let item of floorplansOptions" [ngValue]="item">{{item.name}}</option>
    </select>
  </clr-select-container>



  <div class="floorplan-buttons">
    <button type="button" class="btn btn-outline-danger" (click)="removeFloorplan();">
      Delete floorplan...
    </button>
    <button type="button" class="btn btn-secondary" (click)="showAddFloorPlan = true;">
      Add floorplan
    </button>
  </div>

  <button *ngIf="saveEnabled" type="button" class="btn btn-link" (click)="saveFloorplans();">
    Save plans
  </button>
  <button *ngIf="saveEnabled && showSaved" class="btn btn-link" [disabled]="true">Floorplans saved</button>
</form>


<div style="max-width:1200px;">
  <app-bms-floorplan-editor *ngIf="selectedPlan" [floorPlan]="selectedPlan"></app-bms-floorplan-editor>
</div>
